import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { theme } from "./theme";
import { applyTenantBranding } from "./branding";
import "./fonts.css";
import "./design-tokens.css";
import "./styles.css";

// Tenant-branded builds re-anchor the --tinta-* CSS vars before first paint
// (so token-based styling matches the MUI palette) and retitle the tab.
applyTenantBranding();

// CD: frontend-only changes deploy via the `deploy-web` job only (no backend image build).
const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* basename tracks the Vite `base` (BASE_URL): "/" in dev, "/admin/" in the
          staging build so routes resolve under https://vera.prepa.in/admin. */}
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
);
